<template>
  <b-modal 
  :visible="isBannerDetailSidebarActive"
  size="l"
  hide-footer
  
  @change="(val) => $emit('update:is-banner-detail-sidebar-active', val)"
  @shown="getData(imageData)"

  >
  <template #modal-title>
    Image  {{ Data?Data.id:'' }}
  </template>
  <validation-observer
       #default="{ handleSubmit }"
       ref="refFormObserver"
     >
     <b-form
         class="p-2"
         @submit.prevent="handleSubmit(onSubmit)"
         @reset.prevent="resetForm"
       >

       <b-tabs content-class="mt-1" v-if="langs.length > 0">
          <b-tab v-for="(lang,key) in langs" :key="'tab-'+key"  :title="lang.name">

          <validation-provider
           #default="validationContext"
           :name="'title_'+lang.code"
           rules="required"
         >
           <b-form-group
             label="Title"
             :label-for="'title_'+lang.code"
           >
             <b-form-input
               :id="'title_'+lang.code"
               v-model="Data.title[lang.code]"
               autofocus
               :state="getValidationState(validationContext)"
               trim
               :placeholder="'Title ('+lang.code+')'"
             />

             <b-form-invalid-feedback>
               {{ validationContext.errors[0] }}
             </b-form-invalid-feedback>
           </b-form-group>
          </validation-provider>
          <validation-provider
           #default="validationContext"
           :name="'sub_title_'+lang.code"
           rules="min:0"
         >
           <b-form-group
             label="Sub Title"
             :label-for="'sub_title_'+lang.code"
           >
             <b-form-input
               :id="'sub_title_'+lang.code"
               v-model="Data.sub_title[lang.code]"
               autofocus
               :state="getValidationState(validationContext)"
               trim
               placeholder="Sub Title"
             />

             <b-form-invalid-feedback>
               {{ validationContext.errors[0] }}
             </b-form-invalid-feedback>
           </b-form-group>
          </validation-provider>
          <validation-provider
           #default="validationContext"
           :name="'short_descripiton_'+lang.code"
           rules="min:0"
         >
           <b-form-group
             label="Short Description"
             :label-for="'short_descripiton_'+lang.code"
           >
           <quill-editor
                      :options="editorOptions"
                      :id="'short_descripiton_' + lang.code"
                      v-model="Data.short_description[lang.code]"
                    />
            
             
            
             <b-form-invalid-feedback>
               {{ validationContext.errors[0] }}
             </b-form-invalid-feedback>
           </b-form-group>
          </validation-provider>
          <validation-provider
           #default="validationContext"
           :name="'url_'+lang.code"
           rules="min:0"
         >
           <b-form-group
             label="Url"
             :label-for="'url_'+lang.code"
           >
             <b-form-input
               :id="'url_'+lang.code"
               v-model="Data.url[lang.code]"
               autofocus
               :state="getValidationState(validationContext)"
               trim
               :placeholder="'Url ('+lang.code+')'"
             />

             <b-form-invalid-feedback>
               {{ validationContext.errors[0] }}
             </b-form-invalid-feedback>
           </b-form-group>
          </validation-provider>
        </b-tab>
        </b-tabs>
        <hr>
          <validation-provider
           #default="validationContext"
           name="IsActive"
           rules="min:0"
         >
           <b-form-group
             label="Is Active"
             label-for="IsActive"
           >
           
             <b-form-checkbox
             id="isactive"
                             checked="true"
                             class="custom-control-success"
                             v-model="Data.is_active"
                             switch
               />

             <b-form-invalid-feedback>
               {{ validationContext.errors[0] }}
             </b-form-invalid-feedback>
           </b-form-group>
         </validation-provider>
         <div class="d-flex mt-2">
           <b-button
             v-ripple.400="'rgba(255, 255, 255, 0.15)'"
             variant="primary"
             class="mr-2"
             type="submit"
           >
             Submit
           </b-button>
           <b-button
             v-ripple.400="'rgba(186, 191, 199, 0.15)'"
             type="button"
             variant="outline-secondary"
             @click="hide_form"
           >
             Cancel
           </b-button>
         </div>
      </b-form>
  </validation-observer>

  </b-modal>
</template>
<script>
import { $themeConfig } from '@themeConfig'
import {
  BForm, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,
  BTabs,BTab
} from 'bootstrap-vue'
import {
BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref,onUnmounted } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email, password,confirmed } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import languagesStoreModule from '@/views/languages/languagesStoreModule'
import { quillEditor } from "vue-quill-editor";
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";

export default {
  components: {
      BButton,
      BFormGroup,
      BFormInput,
      BListGroup,
      BListGroupItem,
      BModal,
      ValidationProvider,
      ValidationObserver,
      BTabs,BTab,
      BForm, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BCard,BCardText,BMedia,BMediaAside,BMediaBody,BAvatar,BImg,BLink,
      quillEditor
  },
  directives: {
      'b-modal': VBModal,
      Ripple,
  },
  model: {
   prop: 'isBannerDetailSidebarActive',
   event: 'update:is-banner-detail-sidebar-active',
 },
  props: {
  isBannerDetailSidebarActive: {
     type: Boolean,
     required: true,
   },
  
   imageData: {
     type: Object,
     required: false,
   },
  },
  computed: {
    editorOptions (){
      return $themeConfig.snowOption
    } 
  },
 setup(props, { emit }){
  const toast = useToast()
  const langs = ref([]);
  const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
      if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
      onUnmounted(() => {
          if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
      });
  const blankData = {
      id:'',
      image:require('@/assets/images/no-image.png'),
      title:{},
      sub_title:{},
      short_description:{},
      url:{}
  };
  const Data = ref(JSON.parse(JSON.stringify(blankData)))
  const getData = (data)=>{
  
      if(data){
          data.is_active = data.is_active?true:false;
          Data.value  = JSON.parse(JSON.stringify(data));
      }
  }
  const resetData = () => {
         Data.value = JSON.parse(JSON.stringify(blankData))
  }
  const getLangs = (fil)=>{
        store.dispatch('app-languages/fetchData', fil)
               .then((res) => {
                   if(res.data.success){
                     langs.value = res.data.data;
                     
                   }
                   
                 
        });
     }
     let filter = {
      is_active:1,
          
     }
      getLangs(filter);
  const onSubmit = async () => {
      //updateImageData
      Data.value.is_active = Data.value.is_active?1:0;
      store.dispatch('app-banner/updateImageData', Data.value)
              .then((res) => {
                  
                  if(res.data.success){
                  toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                      title: `Success`,
                      icon: 'BellIcon',
                      variant: 'success',
                      text: `${res.data.message}`,
                      },
                  });
                  emit('refetch-data')
                  emit('update:is-banner-detail-sidebar-active', false)
                  }else{
                  
                  toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                      title: `Error`,
                      icon: 'BellIcon',
                      variant: 'danger',
                      text: `${res.data.message}`,
                      },
                  });
              
                  
                  }
              
              })

  }
  const hide_form = ()=>{
      emit('update:is-banner-detail-sidebar-active', false)
  }
  const {
     refFormObserver,
     
    
     getValidationState,
     resetForm,
   } = formValidation(resetData)
  return {
      onSubmit,
      getData,
      Data,
      refFormObserver,
     getValidationState,
     resetForm,
     resetData,
    
     hide_form,
     langs,
  }

 }
}
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";
</style>